import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xl-12" }
const _hoisted_6 = { class: "panel" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr mt-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode(" Filtros del"),
    /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
      /*#__PURE__*/_createElementVNode("i", null, "reporte")
    ])
  ])
], -1)
const _hoisted_8 = { class: "panel-container" }
const _hoisted_9 = { class: "panel-content" }
const _hoisted_10 = {
  key: 0,
  class: "col-xl-12"
}
const _hoisted_11 = { class: "panel" }
const _hoisted_12 = { class: "panel-hdr mt-2" }
const _hoisted_13 = { class: "fw-300" }
const _hoisted_14 = { class: "panel-container" }
const _hoisted_15 = { class: "panel-content" }
const _hoisted_16 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "badge badge-secondary ml-1" }
const _hoisted_19 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" }, null, -1)
const _hoisted_21 = { class: "row mb-2" }
const _hoisted_22 = { class: "col-xl-3 col-lg-4 col-md-5 col-12" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_25 = {
  key: 0,
  class: "col text-right"
}
const _hoisted_26 = { class: "text-right" }

import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import numeral from 'numeral';

import FiltroReporteComponent from '../components/FiltroReporteComponent.vue';
import useReportes, { FiltrosReporte } from '../composables/useReportes';
import { exportarReporteExcel } from '../utils/exportarExcel';
import {
    REPORTES,
    FORMATO_NUMERAL,
    TipoColumna,
    calcularTotales,
    normalizarFilas,
} from '../utils/reportesConfig';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReporteView',
  setup(__props) {

const route = useRoute();
const store = useStore();
const { obtenerReporte } = useReportes();

// Las cinco rutas del módulo usan esta misma vista; el reporte sale de meta.reporte.
const config = computed(() => REPORTES[route.meta.reporte as string]);

const datos = ref<Record<string, any[]>>({});
const extra = ref({ sucursal: '', periodo: '', granularidad: '' });
const filtrosCargados = ref<FiltrosReporte | null>(null);
const hojaActivaKey = ref('');
const textoBuscar = ref('');

const hojaActiva = computed(() =>
    config.value.hojas.find((h) => h.key === hojaActivaKey.value) || config.value.hojas[0]
);

const hojasOmitidas = computed(() =>
    filtrosCargados.value?.mes === 0
        ? config.value.hojas.filter((h) => h.soloConMes).map((h) => h.key)
        : []
);
const hojaOmitida = computed(() => hojasOmitidas.value.includes(hojaActiva.value.key));

const headers = computed(() =>
    hojaActiva.value.columnas.map((c) => ({ text: c.header, value: c.key, sortable: true }))
);
const columnasNumericas = computed(() => hojaActiva.value.columnas.filter((c) => c.tipo !== 'texto'));
const columnasConTotal  = computed(() => hojaActiva.value.columnas.filter((c) => c.total));
const totales = computed(() => calcularTotales(hojaActiva.value, datos.value[hojaActiva.value.key] || []));

const formatear = (valor: number, tipo: TipoColumna) => numeral(valor).format(FORMATO_NUMERAL[tipo]);

const mismosFiltros = (a: FiltrosReporte | null, b: FiltrosReporte) =>
    !!a && a.idSucursal === b.idSucursal && a.anio === b.anio && a.mes === b.mes && a.dia === b.dia;

const limpiar = () => {
    datos.value = {};
    filtrosCargados.value = null;
    hojaActivaKey.value = '';
    textoBuscar.value = '';
};

// Al pasar de un reporte a otro desde el menú el componente se reutiliza.
watch(() => route.name, limpiar);
watch(hojaActivaKey, () => { textoBuscar.value = ''; });

const cargar = async (filtros: FiltrosReporte) => {
    const respuesta = await obtenerReporte(config.value.endpoint, filtros);
    if (!respuesta.ok) return false;

    const normalizados: Record<string, any[]> = {};
    config.value.hojas.forEach((hoja) => {
        normalizados[hoja.key] = normalizarFilas(hoja, respuesta.datos[hoja.key] || []);
    });

    datos.value = normalizados;
    extra.value = respuesta.extra;
    filtrosCargados.value = { ...filtros };
    return true;
};

const verReporte = async (filtros: FiltrosReporte) => {
    await cargar(filtros);
};

const nombreArchivo = (filtros: FiltrosReporte) => {
    const dos = (n: number) => n.toString().padStart(2, '0');
    const sucursal = extra.value.sucursal
        .toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_|_$/g, '');

    return `reporte_${ config.value.archivo }_${ sucursal }_${ filtros.anio }`
        + (filtros.mes ? `_${ dos(filtros.mes) }` : '')
        + (filtros.dia ? `_${ dos(filtros.dia) }` : '')
        + '.xlsx';
};

// Si los filtros cambiaron desde la última consulta, primero se vuelve a consultar.
const exportarExcel = async (filtros: FiltrosReporte) => {
    if (!mismosFiltros(filtrosCargados.value, filtros)) {
        const ok = await cargar(filtros);
        if (!ok) return;
    }

    await exportarReporteExcel(config.value, datos.value, {
        sucursal: extra.value.sucursal,
        periodo: extra.value.periodo,
        usuario: store.getters['auth/getFullNameUser'] || store.getters['auth/getUserName'] || '',
        nombreArchivo: nombreArchivo(filtros),
        hojasOmitidas: hojasOmitidas.value,
    });
};

return (_ctx: any,_cache: any) => {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(['subheader-icon', 'fal', _unref(config).icono])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_unref(config).titulo) + " ", 1),
        _createElementVNode("small", null, _toDisplayString(_unref(config).descripcion), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(FiltroReporteComponent, {
                onVer: verReporte,
                onExportar: exportarExcel
              })
            ])
          ])
        ])
      ]),
      (filtrosCargados.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(extra.value.sucursal), 1),
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("i", null, _toDisplayString(extra.value.periodo), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).hojas, (hoja) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "nav-item",
                        key: hoja.key
                      }, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: _normalizeClass(['nav-link', { active: hoja.key === _unref(hojaActiva).key }]),
                          onClick: ($event: any) => (hojaActivaKey.value = hoja.key)
                        }, [
                          _createTextVNode(_toDisplayString(hoja.nombre) + " ", 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString((datos.value[hoja.key] || []).length), 1)
                        ], 10, _hoisted_17)
                      ]))
                    }), 128))
                  ]),
                  (_unref(hojaOmitida))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(" Esta hoja se genera al filtrar por un mes o un día específico. ")
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control form-control-sm",
                                placeholder: "Buscar",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textoBuscar).value = $event))
                              }, null, 512), [
                                [_vModelText, textoBuscar.value]
                              ])
                            ])
                          ]),
                          (_unref(columnasConTotal).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnasConTotal), (col) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: col.key,
                                    class: "badge badge-light border ml-1 p-2"
                                  }, [
                                    _createTextVNode(_toDisplayString(col.header) + ": ", 1),
                                    _createElementVNode("b", null, _toDisplayString(formatear(_unref(totales)[col.key], col.tipo)), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_EasyDataTable, {
                          headers: _unref(headers),
                          items: datos.value[_unref(hojaActiva).key] || [],
                          "search-value": textoBuscar.value,
                          "rows-per-page": 25,
                          "border-cell": "",
                          alternating: "",
                          "buttons-pagination": ""
                        }, _createSlots({ _: 2 }, [
                          _renderList(_unref(columnasNumericas), (col) => {
                            return {
                              name: `item-${col.key}`,
                              fn: _withCtx((item) => [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(formatear(item[col.key], col.tipo)), 1)
                              ])
                            }
                          })
                        ]), 1032, ["headers", "items", "search-value"])
                      ], 64))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})